"use client";
import{useAnalyticsContext as r}from"../context/index.js";import{Logger as e}from"../../utils/logger.js";function o(){const{triggerImpressions:o}=r();return o||(e.error("triggerImpressions is not defined"),()=>{})}export{o as default};
